@let data = model();
@let columnData = column();

@switch (columnData.key) {
  @case (getColumnKey('logoUrl')) {
    @if (isNotNil(data.logoUrl)) {
      <app-image-thumbnail>
        <img
          [ngSrc]="data.logoUrl!"
          [fill]="true"
          [alt]="data.logoAlt"
          class="object-contain" />
      </app-image-thumbnail>
    } @else {
      <app-image-thumbnail-unsupported />
    }
  }

  @case (getColumnKey('name')) {
    <div class="flex flex-wrap items-center gap-2">
      <span>{{ data.name }}</span>

      @if (!data.isShown) {
        <span
          class="inline-flex rounded-full bg-rose-50 px-2 py-0.5 text-[0.625rem] font-semibold tracking-[0.08em] text-rose-600 uppercase">
          Nowe
        </span>
      }
    </div>
  }

  @case (getColumnKey('hasError')) {
    @if (data.hasError) {
      <div
        class="flex items-center gap-2 text-red-500"
        tooltipPosition="bottom"
        [pTooltip]="data.errorMessage!">
        <app-icon [icon]="Icon.ExclamationCircleFill" />

        <span class="text-xs">Najedź kursorem, aby zobaczyć szczegóły</span>
      </div>
    } @else {
      <app-no-data />
    }
  }

  @case (getColumnKey('status')) {
    <app-box-questionnaire-status [status]="data.status" />
  }

  @case (getColumnKey('selectTypes')) {
    @if (data.selectTypes) {
      @for (selectType of data.selectTypes; track selectType) {
        <app-box-questionnaire-select-type [selectType]="selectType" />
      }
    } @else {
      <app-no-data />
    }
  }

  @case (getColumnKey('endDate')) {
    <app-date-time [date]="data.endDate" />
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="columnData.key" />
  }
}
